import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
@Component({
  selector: "app-watchlist-dropdown",
  templateUrl: "./watchlist-dropdown.component.html",
  styleUrls: ["./watchlist-dropdown.component.scss"],
})
export class WatchlistDropdownComponent implements OnInit {
  apiUrl: string = window.apiUrl;
  watchlistId = 0;
  watchlistDD: any = [];
  isWatchlistDataLoaded = false;
  @Input("userId") userId: string;
  @Output("selectWatchlistFunc") selectWatchlistFunc: EventEmitter<any> =
    new EventEmitter();
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getWatchlists();
  }
  /* cases
      1) watchlist services is down and user has watcher access
          -   show activity feed and watchlist drop down(dropdown wil appear as blank)
      2) watchlist service is up and user doesn't have watcher access
          -   show activity feed div without watchlist drop down
      3) watchlist service is up and user has watcher access
          -   show activity feed div with watchlist dropdown(dropdown with data)
  */
  getWatchlists() {
    this.http
      .get(`${this.apiUrl}/watcher/get_watchers_only/?userid=${this.userId}`)
      .subscribe(
        (respObject: any) => {
          // when watcher service is down but user has watcher access, API sends response as 'success' but with 'failure' flag
          if (respObject.status !== "failure") {
            this.watchlistDD = respObject.data;
            const isWatchListSet = this.watchlistDD.length !== 0 ? true : false;
            for (const item of this.watchlistDD) {
              const displayWatchName =
                item.w_name +
                (item.w_owner_name !== undefined
                  ? `(${item.w_owner_name})`
                  : "");
              item["w_displayname"] = displayWatchName;
            }
            this.watchlistDD.unshift({
              w_id: 0,
              w_name: "Select Watchlist",
              w_displayname: "Select Watchlist",
            });
            if (!isWatchListSet) {
              this.watchlistDD.push({
                w_id: -2,
                w_name: "Create Watchlist",
                w_displayname: "Create New Watchlist",
              });
            }
            this.watchlistId = this.watchlistDD[0].w_id;
            /* set to keep track of weather to show watchlist dropdown or not */
            this.isWatchlistDataLoaded = true;
          } else {
            this.isWatchlistDataLoaded = false;
          }
          // set heights for all columns after promise.all
        },
        function error(errObject) {
          throw errObject;
        },
      );
  }
  selectWatchlist(): void {
    // For a create watchlist event
    if (this.watchlistId === -2) {
      // redirect to watchlist page
      this.router.navigateByUrl("/watchlist");
      return;
    }
    this.selectWatchlistFunc.emit(this.watchlistId);
  }

  // For resetting/changing value from outside
  changeValue(id): void {
    this.watchlistId = id;
  }
}
